//import { getAccessToken } from '@auth0/nextjs-auth0';

export const APIOptionsGET = () => {
  //const accessToken = getAccessToken()

  return {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      //Authorization: `Bearer ${accessToken}`
    },
  }
}

export const APIOptionsPOST = (variables: unknown) => {
  return {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(variables),
  }
}
